import { render, staticRenderFns } from "./ordercategory.vue?vue&type=template&id=00c0be7c&"
import script from "./ordercategory.vue?vue&type=script&lang=js&"
export * from "./ordercategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports